import {Component, OnInit, EventEmitter, ViewEncapsulation, AfterViewInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {ModulesService} from '../../../_services/modules.service';
import {LineBotService} from '../../../_services/line-bot.service';
import {TelegramChannelService} from '../../../_services/telegram-channel.service';
import {ModulesModel} from '../../../_models/modules'
import {Observable} from 'rxjs/Observable';
import {CategoryMoneyService} from '../../../_services/category-money.service';
import {forEach} from "@angular/router/src/utils/collection";
import {element} from "protractor";
import {SendSignalService} from "../../../_services/send-signal.service";
import {PopupShowListCoinComponent} from "../../send-signal-event/popup-show-list-coin/popup-show-list-coin.component";

@Component({
    selector: 'app-add-modules',
    templateUrl: './add-modules.component.html',
    styleUrls: ['./add-modules.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class AddModulesComponent extends DialogComponent<ModulesModel, boolean> implements AfterViewInit, OnInit {

    model: any = {};
    loading = false;
    message: string;
    constantModules: any;
    freeLineBotID: number;
    focusEventEmitter = new EventEmitter<boolean>();
    arrData: any = [];
    arrPush: any[] = [];
    categoryMoneyAlls: Observable<any[]>;
    addModuleFunctionSignalEvents: any = [];
    functionSendSignalPrice: any = [];
    booleanSendSignalEvent: boolean = false;
    objPopUp: any;
    getLineBot: Observable<any[]>;

    constructor(
        dialogService: DialogService,
        private modulesService: ModulesService,
        private categoryMoneyService: CategoryMoneyService,
        private lineBotService: LineBotService,
        private telegramChannelService: TelegramChannelService,
        private sendSignalService: SendSignalService
    ) {
        super(dialogService);
        this.getLineBot = this.lineBotService.getLineBot();
        this.sendSignalService.getAllFunctionForUser().subscribe(childFunctionForUser => {
            this.addModuleFunctionSignalEvents = childFunctionForUser;
        })
    }

    ngOnInit() {
        let self = this;
        this.freeLineBotID = +this.constantModules.freeLineBotID;
        this.arrData = this.constantModules.modules;

        this.lineBotService.getLineBot().subscribe(res => {
            res.forEach(item => {
                if (item.id !== self.freeLineBotID) {
                    let keyLine = 'LINE' + item.id;
                    let existLine = Object.keys(self.arrData).some(function (key) {
                        return self.arrData[key].value == keyLine;
                    });
                    if (!existLine) {
                        let objLineBot = {
                            value: 'LINE' + item.id,
                            name: item.linebot_channel_name + ' (BitLion)'
                        };
                        self.arrData.push(objLineBot);
                    }
                }
            });
        });

        this.getLineBot.subscribe(res => {
            res.forEach(item => {
                let keyIOS = 'IOS' + item.id;
                let exist = Object.keys(self.arrData).some(function (key) {
                    return self.arrData[key].value == keyIOS;
                });
                if (!exist) {
                    let objIos = {
                        value: keyIOS,
                        name: item.linebot_channel_name + ' (BitLion iOSアプリ)'
                    };
                    self.arrData.push(objIos);
                }
            });
            self.checkShowModuleFunctionSignal([]);
        });

        this.telegramChannelService.getTelegram().subscribe(res => {
            res.forEach(item => {
                let keyTelegram = 'TELEGRAM' + item.id;
                let existTelegram = Object.keys(self.arrData).some(function (key) {
                    return self.arrData[key].value == keyTelegram;
                });
                if (!existTelegram) {
                    let objTelegram = {
                        value: keyTelegram,
                        name: item.name_telegram_channel + ' (Telegram)'
                    };
                    self.arrData.push(objTelegram);
                }
            });
        });

        this.categoryMoneyAlls = this.categoryMoneyService.getAll();
    }

    ngAfterViewInit() {
        let self = this;
        setTimeout(() => {
            self.focusEventEmitter.emit(true);
            self.checkShowModuleFunctionSignal([]);
        },3000);
    }

    toggleSelect() {
        if ($('#select-checkbox').is(':checked')) {
            $('.checkbox').prop('checked', true);
            for (var i = 0; i < this.arrData.length; i++) {
                this.arrPush.push(this.arrData[i].value);
            }
        } else {
            this.arrPush = [];
            $('.checkbox').prop('checked', false);
        }

        this.checkShowModuleFunctionSignal(this.arrPush);
    }

    selectChecked(event, value) {
        if (event.target.checked) {
            this.arrPush.push(value);
        } else {
            this.arrPush.splice(this.arrPush.indexOf(value), 1);
        }

        this.checkShowModuleFunctionSignal(this.arrPush);
    }

    add() {
        if ($.unique(this.arrPush).length == 0) {
            $("label.failure").fadeIn(300).delay(3000).fadeOut(400);
            return false;
        }
        this.loading = true;
        this.message = '';
        this.model.dataModuleFunction = $.unique(this.arrPush);
        this.model.categoryMoney = $('#categoryMoney').val();
        this.model.sendSignalFunctionPrices = this.getObjectFunctionSendPriceForUser();

        this.modulesService.add(this.model).subscribe(data => {
            if (data.error) {
                this.message = data.message;
            } else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        })
    }

    checkShowModuleFunctionSignal(checkModule?: any[]) {
        let self = this;
        self.addModuleFunctionSignalEvents.forEach((element, index) => {
            // Line bot free
            if (element.isFree == true) {
                element.nameLineBot = 'Line Bot Free (BitLion)';
                element.isCheckLineBot = true;
            } else {
                // Line bot not free
                if (checkModule && checkModule.length) {
                    let keyToUpperCase = element.key.toUpperCase();
                    let obj = self.arrData.find((obj) => {
                        return obj.value === keyToUpperCase
                    });
                    if (checkModule.indexOf(keyToUpperCase) !== -1 && obj) {
                        element.nameLineBot = obj.name;
                        element.isCheckLineBot = true;
                    } else {
                        element.isCheckLineBot = false;
                    }
                } else {
                    element.isCheckLineBot = false;
                }
            }
        });

        self.addModuleFunctionSignalEvents.forEach((element, index) => {
            if (element.isCheckLineBot == true && self.booleanSendSignalEvent == false) {
                self.booleanSendSignalEvent = true;
            }
        });
    }

    changeChildModulePrice(event: any, lineBotID) {
        $('#btn-show-' + lineBotID).attr({disabled: event.target.value ? false : true});
    }

    openModalShowCoinPrice(event: any, lineBotID: any) {
        let self = this;
        let codeSendSignalEvent = $('#select-show-' + lineBotID + ' option:selected').val();
        this.sendSignalService.postListCoinNameActive({codeSendSignalEvent: codeSendSignalEvent}).subscribe((resListCoinName: Response) => {
            self.objPopUp = {
                titlePopup: 'ユーザーにプライスを送信するコインの表示',
                listCoinSendSignal: resListCoinName,
            };
            this.dialogService.addDialog(PopupShowListCoinComponent, self.objPopUp).subscribe((isAccess) => {
            });
        });
    }

    getObjectFunctionSendPriceForUser() {
        let self = this;
        let objPrice = self.addModuleFunctionSignalEvents.map((element, index) => {
            let tmpObjPrice = {};
            let valueCode = $('#select-show-' + element.lineBot).is(':hidden')
                ? ''
                : ($('#select-show-' + element.lineBot + ' option:selected').val() || '');

            tmpObjPrice['codeFunctionPrice'] = valueCode.length ? valueCode : null;
            tmpObjPrice['lineBotPrice'] = element.lineBot;
            return tmpObjPrice;
        });

        return objPrice
    }

    checkedOption(valueCheck: any, lineBotID: any) {
        let self = this;
        return Object.keys(self.functionSendSignalPrice).some(function (k) {
            $('#btn-show-' + lineBotID).attr({disabled: (($('#select-show-' + lineBotID + ' option:selected').val() || '').length ? false : true)});
            return self.functionSendSignalPrice[k].codeFunctionPrice == valueCheck;
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/modules/add-modules/add-modules.component.ts